import React from 'react';
import FilterTable from './filterTable';
import { TrialRejectedDevicesTableColumnCaptions } from './tableColumnCaptions';

const TrialRejectedDevicesTable = (props) => {
  const columns = [
    {
      dataField: 'device.key',
      text: TrialRejectedDevicesTableColumnCaptions.device.key,
      sort: true,
      filter_: { type: 'text' },
    }, {
      dataField: 'isOn',
      text: TrialRejectedDevicesTableColumnCaptions.isOn,
      sort: false,
      filter_: {
        type: 'select',
        values: {
          'all': '',
          'true': 'true',
          'false': 'false'
        }
      }
    }
  ];

  return (
    <FilterTable
      {...props}
      objectName={'trialRejectedDevices'}
      data={props.trialRejectedDevices}
      columns={columns}
      noDataIndication="There are no trial rejected devices"
    />
  );
}

export default TrialRejectedDevicesTable;


// WEBPACK FOOTER //
// ./src/components/trialRejectedDevicesTable.js